import { Observable, filter, fromEvent, map, tap } from "rxjs";
import { Option } from "fp-ts/lib/Option";
import { option } from "fp-ts";
import { Failure } from "./failure";

export function getClicks$(
  targetQuery: string,
  root: Element = document.documentElement
): Observable<Element> {
  return fromEvent(root, "click").pipe(
    map(findParentOfEventTarget(targetQuery)),
    filter(option.isSome),
    // tap((x) => console.log(targetQuery)),
    map(option.getOrElseW(() => Failure("Failed to filter out invalid clicks")))
  );
}

/** filters out None observable values, passing on only the inner value of the Some instances */
export function collapse<T>(option$: Observable<Option<T>>): Observable<T> {
  return option$.pipe(
    filter(option.isSome),
    map(option.getOrElseW(() => Failure("Failed to filter out options")))
  );
}

function findParentOfEventTarget(
  parentQuery: string
): (event: Event) => Option<Element> {
  return (event: Event) => {
    const target = event.target as HTMLElement | null;

    const viewTriggerElement = option.fromNullable(
      target?.closest(parentQuery)
    );
    return viewTriggerElement;
  };
}
